import { isNull, journal_entry, type SQL } from "@journal/powersync";

/**
 * SOFT_DELETE_STANDARD — centralized live layer (invariant choke point).
 *
 * `journal_entry` is the ONLY table with a trash feature (L2) in this repo: soft-delete
 * via `deleted_at`. The standard (SOFT_DELETE_STANDARD guide, Rule A) requires
 * the invariant "live views ONLY see non-deleted rows" to live in ONE place
 * instead of being scattered as `isNull(...)` across every query (that dispersion
 * caused a family of bugs: ⌘K search showing trash, checkUnsynced
 * counting deleted rows). Every LIVE read composes these filters; the only
 * legitimate exceptions (the trash itself and by-id reads) are
 * declared in `guard-manifest.ts` and watched by `live-access-guard.test.ts`.
 *
 * The journal schema is FLAT: `journal_entry` has no parent/child hierarchy
 * nor cohort concept (unlike listto: list→todo), so the filter
 * is a single `deleted_at IS NULL` predicate. It returns an ARRAY so
 * callers can spread it inside an `and(...)` alongside their conditions.
 */
export function liveJournalEntryFilters(): [SQL] {
  return [isNull(journal_entry.deleted_at)];
}
